import { createTheme } from "@mui/material";
import { palette } from "./palette";
import { makeTypography } from "./typography";
import MuiButton from "./overrides/MuiButton";

export const theme = createTheme({
    palette,
    typography: makeTypography(palette),
    components: {
        MuiButton: {
            styleOverrides: MuiButton, // Apply the overrides for MuiButton
        },
    },
    
});
